import React from 'react'
import { SVGIconProps } from '../types'
const SvgMusvideo = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M14 2H2C1.267 2 .667 2.6.667 3.333v9.334C.667 13.4 1.267 14 2 14h12c.733 0 1.333-.6 1.333-1.333V3.333C15.333 2.6 14.733 2 14 2m0 10.667H2V3.333h12zM5.333 10c0-1.107.894-2 2-2 .234 0 .46.047.667.12V4h3.333v1.333h-2v4.687a2 2 0 0 1-2 1.98c-1.106 0-2-.893-2-2"
      />
    </g>
  </svg>
)
export default SvgMusvideo
